import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import '../styles/recommendation.scss';
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import CitationComponent from './CitationComponent'
import Recommendation from '../models/Recommendation'
import Answer from '../models/Answer'
import NumPad from './NumPad'
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import * as constants from '../constants/constants'
import Persistence from '../Persistence/Persistence'
import NewLineHelper from '../utils/newLineHelper'
import StringHelper from '../utils/stringHelper'
import TextParser from '../models/TextParser'
import EmailHelper from '../utils/emailHelper'

class RecommendationComponent extends Component {
  constructor() {
    super();
    this.state = {shownCitation: null};
  }

  recommendation(){
    return this.props.recommendation;
  }

  handleReferenceClicked(citation, event) {
    this.setState({shownCitation: citation});
  }

  onRestartClick(event) {
    this.props.navigation.confirmReset();
  }

  onEmailClick(event) {
    var emailText = "";
    if (this.recommendation().emailText != null && this.recommendation().emailText.length > 0) {
      emailText += this.recommendation().emailText;
    }
    else {
      emailText += this.recommendation().recommendationText;
    }
    emailText = TextParser.emailStringFromText(emailText);
    EmailHelper.openEmailClient("Aspirin Results from Aspirin-Guide", emailText, null);
  }

  citationComponentDidCancel(citationComponent) {
    this.setState({shownCitation: null});
  }

  recommendationDisplayText() {
    let blocks = TextParser.TextBlocksFromText(this.recommendation().recommendationText);
    let divs = [];
    for (var i=0;i<blocks.length;i++) {
      let block = blocks[i];
      var d = null;
      if (block.citation != null) {
        d = <span className="reference" key={i} onClick={this.handleReferenceClicked.bind(this, block.citation)}>{block.citation.linkText()}</span>
      }
      else {
        d = <span key={i} dangerouslySetInnerHTML={{__html:block.text}}/>
      }
      divs.push(d);
    }
    return divs;
  }

  render() {
    return (
      <div className={"root"}>
        <div className="recommendationBody">
          {this.props.navigation.navBar()}
        <div className="recommendationContentContainer">
        <div className="recommendationText" ref="recText">
          <div className="textTopGradient"/>
        {this.recommendationDisplayText()}
          </div>
          <div className="recommendationButton" onClick={this.onRestartClick.bind(this)}>Restart Algorithm</div>
          <div className="recommendationButton" onClick={this.onEmailClick.bind(this)}>Email this summary to patient and/or yourself</div>
          </div>
          </div>
        <ReactCSSTransitionGroup transitionName="citation" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
        {this.state.shownCitation != null ? <CitationComponent citation={this.state.shownCitation} delegate={this}/> : null}
      </ReactCSSTransitionGroup>
      </div>

    );
  }

}

RecommendationComponent.propTypes = {
  recommendation: Recommendation,
  // delegate: QuestionComponentDelegate,
};

export default RecommendationComponent;



/** WEBPACK FOOTER **
 ** ./src/components/RecommendationComponent.js
 **/